<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn search-picker">
                <div class="search-ctn-right">
                    <div class="search-name">部门</div>
                    <el-cascader
                        ref="orgCascader"
                        class="search-item"
                        v-model="searchData.OrgId"
                        :options="orgSearchData"
                        :props="cascaderProps"
                        size="small"
                        clearable
                        @change="getSIdData"
                        @visible-change="getOrgTree"
                    ></el-cascader>
                    <div class="search-name">验货员</div>
                    <el-select v-model="searchData.SIds" multiple collapse-tags size="small" class="search-item" filterable placeholder="请选择">
                        <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                    <div class="search-name">验货时间</div>
                    <el-date-picker
                        v-model="dateTime"
                        type="daterange"
                        align="right"
                        size="small"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd"
                        @change="handleChange"
                        class="search-name"
                    ></el-date-picker>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="getPickerTableData">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                        <el-button v-if="isCanTBSet" size="small" icon="el-icon-setting" type="primary" class="search-btn" @click="showTableSetDialog()">表格设置</el-button>
                        <el-button size="small" class="search-btn btn-primary" v-if="permission.export"  @click="exportData">
                        <i class="fa fa-file-excel-o"></i>
                        {{ permission.export }}</el-button>                               
                    </div>
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border=""
                    style="width: 100%"
                    @sort-change="sortChange"
                    :default-sort="{ prop: 'StTotalAmount', order: 'ascending' }"
                    :summary-method="getSummaries"
                    show-summary
                >
                    <template v-for="(col,index) in columnShowSets">
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            v-if="col.ColumnCode == 'Index'"
                            type="index"
                            show-overflow-tooltip
                        >
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else-if="col.ColumnCode == 'OrgName' || col.ColumnCode == 'SName'"
                        >
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            :render-header="renderHeader"
                            v-else
                        >
                        </el-table-column>
                    </template>
                </el-table>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" title="自定义列展示设置" @close="tableSetsVisible = false" :visible.sync="tableSetsVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="tableSetsVisible">
                <tableSets :tableCode="tableCode" @closeDialog="tableSetsVisible = false"></tableSets>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import tableSets from '@/components/common/tableSets_v2.vue';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb,
        tableSets
    },
    data() {
        return {
            isCanTBSet:false,
            tableCode: 'InspectedStat',
            tableSetsVisible: false,
            historyVisible: false,
            dateTime: [],
            orgSearchData: [],
            pickDialogTitle: '',
            sId: '',
            searchData: {
                OrgId: '',
                SId: '',
                SIds: [],
                StartDate: '',
                EndDate: ''
            },
            cascaderProps: {
                emitPath: false,
                expandTrigger: 'hover',
                children: 'Childrens',
                label: 'Name',
                value: 'Id',
                checkStrictly: true
            },
            SIdList: [],
            tableSaleData: [],
            tableSaleDataLength: 0,
            tableData: [],
            tableDataLength: 0,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            columnShowSets: [],
            permission:{},
            SortProp:'',
            SortType:'',
        };
    },
    created() {
        if (this.tableCode) this.getSetsData();
        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        if (day1 == 1) {
            let date1 = new Date(year1, month1, day1, 0);
            this.dateTime.push(date1);
            this.searchData.EndDate = date1;
        } else {
            let date1 = new Date(year1, month1, day1 - 1, 0);
            this.dateTime.push(date1);
            this.searchData.EndDate = date1;
        }
        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1];
        let date2 = new Date(year2, month2, day2, 0);
        this.dateTime.unshift(date2);

        this.searchData.StartDate = date2;
    },
    mounted() {
        this.permission = this.$util.getPermission('InspectionStat');
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getPickerTableData();
        this.getConfigByCodes();
    },
    methods: {
        getConfigByCodes() {
            let codes = ['ygsfkzdylb'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'ygsfkzdylb': //是否可自定义列表
                                this.isCanTBSet = result;
                                break;
                        }
                    }
                }
            });
        },
        renderHeader(h, { column }) {
            const totalAmount = h(
                'div',
                {
                    slot: 'content'
                },
                '验货单据商品总额'
            );
            const orderTotalCount = h(
                'div',
                {
                    slot: 'content'
                },
                '验货单据总数'
            );
            const purTotalCount = h(
                'div',
                {
                    slot: 'content'
                },
                '验货采购单的单据总数'
            );
            const purTotalAmount = h(
                'div',
                {
                    slot: 'content'
                },
                '验货采购单的单据商品总额 = 采购价 * 商品数量'
            );
            const purGoodsTotalCount = h(
                'div',
                {
                    slot: 'content'
                },
                '验货采购单的单据的商品总数'
            );
            const prTotalCount = h(
                'div',
                {
                    slot: 'content'
                },
                '验货采购退货单的单据总数'
            );
            const prTotalAmount = h(
                'div',
                {
                    slot: 'content'
                },
                '验货采购退货单的单据商品总额 = 退货价 * 退货商品数量'
            );
            const prGoodsTotalCount = h(
                'div',
                {
                    slot: 'content'
                },
                '验货采购退货单的单据的商品总数'
            );
            const sTotalCount = h(
                'div',
                {
                    slot: 'content'
                },
                '验货销售单的单据总数'
            );
            const sTotalAmount = h(
                'div',
                {
                    slot: 'content'
                },
                '验货销售单的单据商品总额 = 销售价 * 商品数量'
            );
            const sGoodsTotalCount = h(
                'div',
                {
                    slot: 'content'
                },
                '验货销售单的单据的商品总数'
            );
            const srTotalCount = h(
                'div',
                {
                    slot: 'content'
                },
                '验货销售售后单的单据总数'
            );
            const srTotalAmount = h(
                'div',
                {
                    slot: 'content'
                },
                '验货销售售后单的单据商品总额 = 退货价 * 退货商品数量'
            );
            const srGoodsTotalCount = h(
                'div',
                {
                    slot: 'content'
                },
                '验货销售售后单的单据的商品总数'
            );
            return h('span', [
                h(
                    'el-tooltip',
                    {
                        props: {
                            placement: 'bottom'
                        }
                    },
                    [
                        column.property == 'TotalAmount' ? totalAmount : '',
                        column.property == 'OrderTotalCount' ? orderTotalCount : '',
                        column.property == 'PurGoodsTotalCount' ? purGoodsTotalCount : '',
                        column.property == 'PurTotalAmount' ? purTotalAmount : '',
                        column.property == 'PurTotalCount' ? purTotalCount : '',
                        column.property == 'PRGoodsTotalCount' ? prGoodsTotalCount : '',
                        column.property == 'PRTotalAmount' ? prTotalAmount : '',
                        column.property == 'PRTotalCount' ? prTotalCount : '',
                        column.property == 'SGoodsTotalCount' ? sGoodsTotalCount : '',
                        column.property == 'STotalAmount' ? sTotalAmount : '',
                        column.property == 'STotalCount' ? sTotalCount : '',
                        column.property == 'SRGoodsTotalCount' ? srGoodsTotalCount : '',
                        column.property == 'SRTotalAmount' ? srTotalAmount : '',
                        column.property == 'SRTotalCount' ? srTotalCount : '',
                        h('i', {
                            class: 'el-icon-warning-outline',
                            style: 'color:orange;margin-right:5px;'
                        })
                    ]
                ),
                h('span', column.label)
            ]);
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    let strL = sums[index] + '';
                    if (strL.indexOf('.') > -1) {
                        let str = strL.split('.')[1];
                        if (str.length > 2) {
                            sums[index] = sums[index].toFixed(2);
                        }
                    }
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        // 重置表单
        resetSearch() {
            this.$refs.orgCascader.$refs.panel.clearCheckedNodes();
            this.searchData.SId = '';
            this.searchData.SIds = [];
            this.searchData.StartDate = '';
            this.searchData.EndDate = '';
            this.dateTime = [];
            this.searchData.PayStartDate = '';
            this.searchData.PayEndDate = '';
        },
        // 获取数据
        getPickerTableData() {
            this.$util
                .axiosPost({
                    url: '/api/DataStatistics/InsStat_V2',
                    data: this.searchData
                })
                .then(res => {
                    if (res.errcode != 201) {
                        let data = res.data;
                        this.tableData = data;
                        this.tableDataLength = res.count;
                    }
                })
                .catch(() => {});
        },
        //获取组织树
        getSIdData() {
            if (this.searchData.OrgId) {
                this.$util.getSIdListByOrg(this.searchData.OrgId).then(data => {
                    this.SIdList = data;
                });
            }
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        handleChangeFinishTime(val) {
            if (val) {
                this.searchData.PayStartDate = val[0];
                this.searchData.PayEndDate = val[1];
            } else {
                this.searchData.PayStartDate = '';
                this.searchData.PayEndDate = '';
            }
        },
        getOrgTree(isShow) {
            if (isShow && this.orgSearchData.length == 0) {
                this.$util
                    .axiosGet({
                        url: '/api/EntpInfoManagement/GetOrgTree'
                    })
                    .then(res => {
                        if (res.data) {
                            this.orgSearchData = this.getTreeData(res.data);
                        }
                    });
            }
        },
        // 数列
        getTreeData(data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].Childrens.length < 1) {
                    data[i].Childrens = undefined;
                } else {
                    this.getTreeData(data[i].Childrens);
                }
            }
            return data;
        },
        // showStockUpHis(row) {
        //     if (row) {
        //         this.pickDialogTitle = '上架员【' + row.SName + '】上架数据';
        //         this.sId = row.SId;
        //         this.historyVisible = true;
        //     }
        // },
        closeHistoryDialog() {
            this.historyVisible = false;
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        showTableSetDialog() {
            this.tableSetsVisible = true;
        },
        sortChange(event) {
            this.SortProp = event.prop;
            this.SortType = event.order;
        },         
        exportData() {
            let that = this;
            if (that.tableData.length == 0) {
                that.$util.warningMsg('请选择要导出的数据');
                return;
            }
            that.$util.exportFile_post({
                url: '/api/DataStatistics/ExportInsStat',
                data:{InsStats:that.tableData,TableSetsModels:that.columnShowSets,SortProp:that.SortProp,SortType:that.SortType},
            });
        },         
    }
};
</script>